import axios from 'axios';

// Vérifier la validité du token
export const checkResetToken = async (token) => {
    try {
        const response = await axios.post('/auth/reset-password/check', {
            token: token
        });
        
        return response;
    } catch (error) {
        throw error;
    }
};

// Réinitialiser le mot de passe
export const resetPassword = async (token, newPassword, confirmPassword) => {
    try {
        const response = await axios.post('/auth/reset-password', {
            token: token,
            new_password: newPassword,
            confirm_password: confirmPassword
        });
        
        return response;
    } catch (error) {
        throw error;
    }
};
